import { useUser as swUseUser } from "@shopware/composables";
import { ApiClientError } from "@shopware/api-client";

const _useUser = () => {
  const useUserData = swUseUser();
  const { apiClient } = useShopwareContext();
  const { refreshSessionContext } = useSessionContext();
  const { refreshCart } = useCart();
  const { trackLogin } = useGtmEvents()
  const { t } = useI18n();
  const toast = useToast();
  const route = useRoute();

  const loginError = ref("");
  const loggingIn = ref(false);

  async function login({
    username,
    password,
  }: {
    username: string;
    password: string;
  }): Promise<void> {
    loggingIn.value = true;

    try {
      loginError.value = "";
      await apiClient.invoke("loginCustomer post /account/login", {
        body: {
          username,
          password,
      }});
      await refreshSessionContext();
      refreshCart();

      toast.add({
        severity: "success",
        summary: t("account.messages.loggedInSuccess"),
        life: 3000,
      });

      trackLogin()

      await navigateTo({ query: {...route.query, modal: undefined } });
    } catch (error) {
      if (error instanceof ApiClientError) {
        loginError.value = error.details.errors[0].code;
      }
      console.error(error);
    } finally {
      loggingIn.value = false;
    }
  }

  return {
    ...useUserData,
    login,
    loginError,
    loggingIn
  };
};

export const useUser = createSharedComposable(_useUser);
